import React, { useState, useEffect, Fragment, useRef } from 'react';
import { useAlert } from "react-alert";
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box, Card, Grid, TextField, makeStyles, Container, Button, CardContent, Divider, InputLabel, CardHeader, MenuItem, TableRow, TableCell, TableContainer, Table, TableHead, TableBody, TablePagination
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { trackPromise } from 'react-promise-tracker';
import { Formik } from 'formik';
import * as Yup from "yup";
import authService from '../../../../utils/permissionAuth';
import tokenService from '../../../../utils/tokenDecoder';
import { useNavigate } from 'react-router-dom';
import xlsx from 'json-as-xlsx';
import ReactToPrint from "react-to-print";
import CreatePDF from './CreatePDF';
import { LoadingComponent } from '../../../../utils/newLoader';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  colorCancel: {
    backgroundColor: "red",
  },
  colorRecord: {
    backgroundColor: "green",
  },
}));

const screenCode = 'MANUALTRANSACTIONREPORT';

export default function ManualTransactionReport(props) {
  const [title, setTitle] = useState("Manual Transaction Details Report");
  const classes = useStyles();
  const [GroupList, setGroupList] = useState([]);
  const [FactoryList, setFactoryList] = useState([]);
  const [routes, setRoutes] = useState();
  const [transactionDetail, setTransactionDetail] = useState({
    groupID: 0,
    factoryID: 0,
    routeID: 0,
    registrationNumber: "",
  });
  const [transactionDetailList, setTransactionDetailList] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [selectedSearchValues, setSelectedSearchValues] = useState({
    groupName: "0",
    factoryName: "0",
    routeName: "0",
    registrationNumber: " "
  })

  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
  });
  const [csvHeaders, SetCsvHeaders] = useState([])
  const navigate = useNavigate();
  const alert = useAlert();
  const componentRef = useRef();
  const [amountTotal, setAmountTotal] = useState(0);
  const [firstLoad, setFirstLoad] = useState({
    load: 0
  })

  useEffect(() => {
    if (transactionDetail.factoryID != null) {
    }
  }, [firstLoad.load]);

  useEffect(() => {
    trackPromise(
      getPermission()
    );
    trackPromise(
      getGroupsForDropdown()
    );
  }, []);

  useEffect(() => {
    getFactoriesForDropdown();
  }, [transactionDetail.groupID]);

  useEffect(() => {
    trackPromise(
      getRoutesByFactoryID()
    )
  }, [transactionDetail.factoryID]);

  async function getPermission() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWMANUALTRANSACTIONREPORT');

    if (isAuthorized === undefined) {
      navigate('/404');
    }
    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
    });

    setTransactionDetail({
      ...transactionDetail,
      groupID: parseInt(tokenService.getGroupIDFromToken()),
      factoryID: parseInt(tokenService.getFactoryIDFromToken())
    })

    setFirstLoad({
      ...firstLoad,
      load: 1
    })
  }

  async function getGroupsForDropdown() {
    const groups = await services.getAllGroups();
    setGroupList(groups);
  }

  async function getFactoriesForDropdown() {
    const factories = await services.getFactoryByGroupID(transactionDetail.groupID);
    setFactoryList(factories);
  }

  async function getRoutesByFactoryID() {
    const routeList = await services.getRoutesForDropDown(transactionDetail.factoryID);
    setRoutes(routeList);
  }

  async function GetManualTransactionDetails() {
    let model = {
      groupID: parseInt(transactionDetail.groupID),
      factoryID: parseInt(transactionDetail.factoryID),
      routeID: parseInt(transactionDetail.routeID),
      registrationNumber: String(transactionDetail.registrationNumber),
    };
    getSelectedDropdownValuesForReport(transactionDetail.groupID, transactionDetail.factoryID, transactionDetail.routeID, transactionDetail.registrationNumber);
    let ManualTransactionDetails = await services.GetManualTransactionDetails(model);

    if (ManualTransactionDetails.statusCode == 'Success' && ManualTransactionDetails.data != null) {
      setTransactionDetailList(ManualTransactionDetails.data);
      CalTotal(ManualTransactionDetails.data);
      if (ManualTransactionDetails.data.length == 0) {
        alert.error('No Records');
      }
    } else {
      alert.error('Error');
    }
  }

  function generateDropDownMenu(data) {
    let items = []
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
      }
    }
    return items;
  }

  function CalTotal(data) {
    let amountSum = 0;

    data.forEach(element => {
      amountSum += parseFloat(element.amount);
    });

    let amountTotal = amountSum;
    setAmountTotal(amountTotal.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }));
    return amountTotal;
  }

  async function createDataForExcel(array) {
    var res = [];
    let totalAmount = CalTotal(array);

    if (array != null) {
      array.map(x => {
        var vr = {
          'Route Name': x.routeName,
          'Reg No': x.registrationNumber,
          'Name': x.name,
          'Transaction Type': x.transactionTypeName,
          'Amount': x.amount,
          'Effective Date': x.effectiveDate.split('T')[0],
          'Description': x.description !== null ? x.description : " - "
        }
        res.push(vr);
      });
      var vr = {
        'Route Name': 'Total',
        'Amount': totalAmount
      }
      res.push(vr);
      res.push({});

      var vr = {
        'Route Name': "Group :" + selectedSearchValues.groupName,
        'Reg No': "Factory :" + selectedSearchValues.factoryName,
      }
      res.push(vr);

      var vr = {
        'Route Name': selectedSearchValues.routeName == undefined ? 'Route :' + 'All Routes' : 'Route :' + selectedSearchValues.routeName,
        'Reg No': selectedSearchValues.registrationNumber === "" ? 'Reg No :' + 'All Reg No' : 'Reg No :' + selectedSearchValues.registrationNumber,
      }
      res.push(vr);

    }
    return res;
  }

  async function createFile() {

    var file = await createDataForExcel(transactionDetailList);
    var settings = {
      sheetName: 'Manual Transation Report',
      fileName: 'Manual Transation Report - ' +
        selectedSearchValues.groupName + ' - ' +
        selectedSearchValues.factoryName +
        (selectedSearchValues.routeName == undefined || selectedSearchValues.routeName == '0' ? "" : " - " + selectedSearchValues.routeName) +
        (selectedSearchValues.registrationNumber == '' ? "" : " - RegistrationNumber - " + selectedSearchValues.registrationNumber),
      writeOptions: {}
    }

    let keys = Object.keys(file[0])
    let tempcsvHeaders = csvHeaders;
    keys.map((sitem, i) => {
      tempcsvHeaders.push({ label: sitem, value: sitem })
    })

    let dataA = [
      {
        sheet: 'Manual Transation Report',
        columns: tempcsvHeaders,
        content: file
      }
    ]

    xlsx(dataA, settings);
  }

  function handleChange(e) {
    const target = e.target;
    const value = target.value
    setTransactionDetail({
      ...transactionDetail,
      [e.target.name]: value
    });
    setTransactionDetailList([]);
  }

  function getSelectedDropdownValuesForReport(groupID, factoryID, routeID, registrationNumber) {
    setSelectedSearchValues({
      ...selectedSearchValues,
      groupName: GroupList[groupID],
      factoryName: FactoryList[factoryID],
      routeName: routes[routeID] !== 0 ? routes[routeID] : "0",
      registrationNumber: registrationNumber
    })
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
      </Grid>
    )
  }

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };
  const handleLimitChange = event => {
    setRowsPerPage(event.target.value);
  };

  const getPageMargins = () => {
    return `@media print {
        @page {
            background-color: white !important;
        }
   
        body {
            background-color: white !important;
        }
    }`;
  };
  return (
    <Fragment>
      <LoadingComponent />
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: transactionDetail.groupID,
              factoryID: transactionDetail.factoryID
            }}
            validationSchema={
              Yup.object().shape({
                groupID: Yup.number().required('Group is required').min("1", 'Group is required'),
                factoryID: Yup.number().required('Factory is required').min("1", 'Factory is required'),
              })
            }
            onSubmit={() => trackPromise(GetManualTransactionDetails())}
            enableReinitialize
          >
            {({
              errors,
              handleBlur,
              handleSubmit,
              touched
            }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader
                      title={cardTitle(title)}
                    />
                    <PerfectScrollbar>
                      <Divider />
                      <CardContent>
                        <Grid container spacing={3}>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="groupID">
                              Group *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.groupID && errors.groupID)}
                              fullWidth
                              helperText={touched.groupID && errors.groupID}
                              size='small'
                              name="groupID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={transactionDetail.groupID}
                              variant="outlined"
                              id="groupID"
                              disabled={!permissionList.isGroupFilterEnabled}
                            >
                              <MenuItem value="0">--Select Group--</MenuItem>
                              {generateDropDownMenu(GroupList)}
                            </TextField>
                          </Grid>

                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="factoryID">
                              Factory *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.factoryID && errors.factoryID)}
                              fullWidth
                              helperText={touched.factoryID && errors.factoryID}
                              size='small'
                              name="factoryID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={transactionDetail.factoryID}
                              variant="outlined"
                              id="factoryID"
                              disabled={!permissionList.isFactoryFilterEnabled}
                            >
                              <MenuItem value="0">--Select Factory--</MenuItem>
                              {generateDropDownMenu(FactoryList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="routeID">
                              Route
                            </InputLabel>
                            <TextField select
                              fullWidth
                              size='small'
                              name="routeID"
                              onChange={(e) => handleChange(e)}
                              value={transactionDetail.routeID}
                              variant="outlined"
                              id="routeID"
                            >
                              <MenuItem value="0">--Select Route--</MenuItem>
                              {generateDropDownMenu(routes)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="registrationNumber">
                              Registration Number
                            </InputLabel>
                            <TextField
                              fullWidth
                              name="registrationNumber"
                              size='small'
                              onChange={(e) => handleChange(e)}
                              value={transactionDetail.registrationNumber}
                              variant="outlined"
                              id="registrationNumber"
                            >
                            </TextField>
                          </Grid>
                        </Grid>
                        <Box display="flex" flexDirection="row-reverse" p={2} >
                          <Button
                            color="primary"
                            type="submit"
                            variant="contained"
                          >
                            Search
                          </Button>
                        </Box>
                      </CardContent>
                      <Box minWidth={1050}>
                        {transactionDetailList.length > 0 ?
                          <TableContainer style={{ padding: '5px' }}  >
                            <Table aria-label="caption table" >
                              <TableHead>
                                <TableRow>
                                  <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "14px", padding: '5px' }} align={'left'}>Route Name</TableCell>
                                  <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "14px", padding: '5px' }} align={'left'}>Registration Number</TableCell>
                                  <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "14px", padding: '5px' }} align={'left'}>Name</TableCell>
                                  <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "14px", padding: '5px' }} align={'left'}>Transaction Type</TableCell>
                                  <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "14px", padding: '5px' }} align={'right'}>Amount </TableCell>
                                  <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "14px", padding: '5px' }} align={'left'}>Effective Date</TableCell>
                                  <TableCell style={{ border: "1px solid black", fontWeight: "bold", fontSize: "14px", padding: '5px' }} align={'left'}>Description</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {transactionDetailList.length > 0 ?
                                  transactionDetailList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((data, index) => (
                                      <TableRow key={index}>
                                        <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid black", fontSize: "14px", padding: '5px' }}>
                                          {data.routeName}
                                        </TableCell>
                                        <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid black", fontSize: "14px", padding: '5px' }}>
                                          {data.registrationNumber}
                                        </TableCell>
                                        <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid black", fontSize: "14px", padding: '5px' }}>
                                          {data.name}
                                        </TableCell>
                                        <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid black", fontSize: "14px", padding: '5px' }}>
                                          {data.transactionTypeName}
                                        </TableCell>
                                        <TableCell align={'right'} component="th" scope="row" style={{ border: "1px solid black", fontSize: "14px", padding: '5px' }}>
                                          {data.amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                        </TableCell>
                                        <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid black", fontSize: "14px", padding: '5px' }}>
                                          {data.effectiveDate.split('T')[0]}
                                        </TableCell>
                                        <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid black", fontSize: "14px", padding: '5px' }}>
                                          {data.description}
                                        </TableCell>
                                      </TableRow>
                                    )) : null}
                              </TableBody>
                              <TableRow>
                                <TableCell align={'left'} style={{ borderBottom: "1px solid black", borderLeft: "1px solid black", fontWeight: "bold", fontSize: "14px", padding: '5px' }}>Total</TableCell>
                                <TableCell component="th" scope="row" style={{ borderBottom: "1px solid black", padding: '5px' }}>
                                </TableCell>
                                <TableCell component="th" scope="row" style={{ borderBottom: "1px solid black", padding: '5px' }}>
                                </TableCell>
                                <TableCell component="th" scope="row" style={{ borderBottom: "1px solid black", padding: '5px' }}>
                                </TableCell>
                                <TableCell align={'right'} component="th" scope="row" style={{ border: "1px solid black", padding: '5px', fontWeight: "bold" }}>
                                  {amountTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                </TableCell>
                                <TableCell component="th" scope="row" style={{ borderBottom: "1px solid black", padding: '5px' }}>
                                </TableCell>
                                <TableCell component="th" scope="row" style={{ borderBottom: "1px solid black", borderRight: "1px solid black", padding: '5px' }}>
                                </TableCell>
                              </TableRow>
                            </Table>
                            <TablePagination
                              component="div"
                              count={transactionDetailList.length}
                              onChangePage={handlePageChange}
                              onChangeRowsPerPage={handleLimitChange}
                              page={page}
                              rowsPerPage={rowsPerPage}
                              rowsPerPageOptions={[25, 50, 100]}
                            />
                          </TableContainer> : null}
                      </Box>

                      {transactionDetailList.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                          <Button
                            color="primary"
                            id="btnRecord"
                            type="submit"
                            variant="contained"
                            style={{ marginRight: '1rem' }}
                            className={classes.colorRecord}
                            onClick={createFile}
                          >
                            EXCEL
                          </Button>

                          <ReactToPrint
                            documentTitle={"Manual Transation Report" + " - " +
                              selectedSearchValues.groupName + ' - ' +
                              selectedSearchValues.factoryName +
                              (selectedSearchValues.routeName == undefined || selectedSearchValues.routeName == '0' ? "" : " - " + selectedSearchValues.routeName) +
                              (selectedSearchValues.registrationNumber == '' ? "" : " - RegistrationNumber - " + selectedSearchValues.registrationNumber)

                            }
                            trigger={() => <Button
                              color="primary"
                              id="btnRecord"
                              type="submit"
                              variant="contained"
                              style={{ marginRight: '1rem' }}
                              className={classes.colorCancel}
                            >
                              PDF
                            </Button>}
                            pageStyle={getPageMargins()}
                            content={() => componentRef.current}
                          />
                          <div hidden={true}>
                            <CreatePDF ref={componentRef}
                              transactionDetailListData={transactionDetailList} selectedSearchValues={selectedSearchValues}
                              totalAmount={amountTotal}
                            />
                          </div>
                        </Box> : null}
                    </PerfectScrollbar>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
    </Fragment>
  );
}
